import { SexArt } from 'src/client/constants/sites';
import { REDGIFS_PROMO } from 'src/client/constants/joinCampaigns';

export type PartnerPromoConfig = {
  assetsDirectory: string;
  campaign: string;
  partnerID: number;
  sitesToDisplay: string[];
  url?: string;
};

type PromoConfig = {
  getPartnerPromoConfig: (partnerID: number, siteAbbreviation: string) => PartnerPromoConfig | undefined;
  promos: PartnerPromoConfig[];
};

export const partnerPromoConfig: PromoConfig = {
  getPartnerPromoConfig: (partnerID, siteAbbreviation) => {
    return partnerPromoConfig.promos.find(
      (promo) => promo.partnerID === partnerID && promo.sitesToDisplay.includes(siteAbbreviation),
    );
  },
  promos: [
    {
      assetsDirectory: 'redgifs-promo',
      campaign: REDGIFS_PROMO,
      partnerID: 8107,
      sitesToDisplay: [SexArt.abbreviation],
    },
  ],
};
